import React from "react";

const Submit = ({ submit }) => {
  return (
    <button type="submit" className="btn btn-primary">
      {submit}&nbsp; <i className="fa fa-angle-right" />
    </button>
  );
};

export default Submit;
